import React from "react";
import styles from "./card.module.css";

function Card(props) {
  const {
    children,
    borderRadius = "0.8vh",
    backgroundColor = "#fff",
    className,
    style = {},
    ...restProps
  } = props;

  return (
    <div
      className={styles.cardContainer + " " + className}
      style={{
        borderRadius,
        backgroundColor,
        ...style,
      }}
      {...restProps}
    >
      {children}
    </div>
  );
}

export default Card;
